// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItensStatus_BuscarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /config/menu_itens_status/buscar_menu_itens_status.
 *
 * Returns all menu item statuses ordered by ID
 * (Menu_itens_status_model::getAll()).
 */
import type { MenuItensStatus_BuscarRow } from './MenuItensStatus_BuscarRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type MenuItensStatus_BuscarResponseDados = MenuItensStatus_BuscarRow[];

export type MenuItensStatus_BuscarResponse = ApiResponse<MenuItensStatus_BuscarResponseDados>;

registerResponseContract('MenuItensStatus_BuscarResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      menu_item_status_id:     { type: 'number',  required: true },
      menu_item_status_titulo: { type: 'string',  required: true },
    },
  },
})
